import React, { useContext, useEffect } from 'react';
import { useStyles } from './AllSortedStyles';
import { DocumentTitle, Typography, YourCoverReceipt, NextSteps, StepChecker } from '../../components/atoms';
import PageTemplate from '../../templates/PageTemplate';
import { StepContext } from '../../contexts/StepContext';
import { Grid, Box } from '@material-ui/core';

export const AllSorted: React.FC = () => {
  const { data, updateShowStepper } = useContext(StepContext);
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
    updateShowStepper(false);
  }, []);

  const coverTypeLong = data.coverType.includes('Annual') ? 'annual multi-trip cover' : 'single trip cover';

  return (
    <PageTemplate>
      <StepChecker />
      <DocumentTitle title={`DLG ${process.env.REACT_APP_SITE_ID?.toUpperCase()} - All Sorted`} />

      <Box className={classes.bgImage}>
        <Box className={classes.allSortedContainer}>
          <Typography className={classes.allSortedHeading} variant="h1">
            ALL SORTED!
          </Typography>
        </Box>

        <Grid className={classes.gridMainContainer}>
          <Grid item xs={12} lg={12} className={classes.gridMain}>
            <Box margin={'1rem 0'}>
              <Typography className={classes.welcome} variant="h1">
                Here&apos;s all the important info about your{' '}
                <span className={classes.greenHighlight}>{coverTypeLong}</span> {data.firstName}.
              </Typography>
            </Box>
            <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} margin={'0 1.2rem'}>
              <YourCoverReceipt startDate={data.policyStartDate} endDate={data.policyEndDate} />
            </Box>
            <NextSteps />
            <Box className={classes.subHeadingSpacing}>
              <Typography className={classes.greenExitText}>
                RIGHT, THAT&apos;S ENOUGH FROM US. <br />
                GO ENJOY THE REST OF YOUR DAY!
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </PageTemplate>
  );
};

export default AllSorted;
